import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ROUTES, facturaPosEditarPath } from '../../config/routes';

const parsePositiveInt = (value: string | undefined): number | undefined => {
  if (!value) return undefined;
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

const FacturaVentaEditarRedirect: React.FC = () => {
  const { nroFormulario } = useParams();
  const id = parsePositiveInt(nroFormulario);

  if (!id) {
    return <Navigate replace to={ROUTES.ventas.facturas.list} />;
  }

  return <Navigate replace to={facturaPosEditarPath(id)} />;
};

export default FacturaVentaEditarRedirect;
